var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"video full-size page",class:_vm.classObject},[_c('video',{staticClass:"full-size",attrs:{"autoplay":"","loop":"","defaultMuted":"","src":"/static/newfilm.mp4"},on:{"click":_vm.play}}),_vm._v(" "),_c('router-link',{staticClass:"close-link bold",attrs:{"to":{ name: 'Home'}}},[_c('img',{staticClass:"arrow",attrs:{"src":"/static/arrow.png"}}),_vm._v(" Back")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-eb0bdd36","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Video.vue
// module id = SfUq
// module chunks = 1